import Team from "../team/team"
import ProjectUserSession from "./project-user-session";
import {UserInheritance} from "../../gd/const/project";
import ProjectSession from "../project/project-session"

// this is edvanced PRoiectUSer Model - used only when we need "watchAll or inheritances??? " like in manage project users...

export default class ProjectUserFull extends ProjectUserSession {

    public watchAll        : boolean

    constructor(data: any) {

        super(data);

        this.watchAll       = _.get(data, 'watchAll', undefined)
    }

    get teams() {
        // Eto otklyuchili. Potomu chto v sluchie esli dobavit user manually, a potom dobavit team s etim user. Mi ne mojem uznat chto etot user v Team.
        // U nego access ostayetsya "Standart". No user naxoditsya v team. Ne znayu naskolko eto pravilno.

        // if (!this.isInheritedTeam) return []

        let teamsIds: ID[] = gd.session.projectUsers.projectTeamIds(this.projectId) || []
        const teams: Team[] = []

        _.map(teamsIds, (teamId: ID) => {
            const team = gd.session.teams.get(teamId)
            if (!!team && team.userIds.includes(this.userId)) {
                teams.push(team)
            }
        })

        return teams
    }

    // what is it for ?
    get minAccess() {
        let res: number | undefined

        if (this.isInheritedTeam) {
            _.map(gd.session.projectUsers.projectTeams(this.projectId), (projectUser: ProjectUserSession) => {
                const team = gd.session.teams.get(projectUser.teamId)
                if (!!team && team.userIds.includes(this.userId)) {     // user belongs to this team
                    if (!res || res < projectUser.access) {             // team projectUser access is higher than current
                        res = projectUser.access                        // set team access as min access for this user
                    }
                }
            })
        }

        return res
    }

    get isInherited():boolean {
        return this.inheritance === UserInheritance.INHERITED
    }

    get isInheritedTeam():boolean {
        return this.inheritance === UserInheritance.INHERITED_TEAM
    }

    get inheritedFromProject(): ProjectSession {
        if (this.isInherited) {
            let project: ProjectSession | undefined
            _.some(this.project.parentProjectsIds, (id:ID) => {
                const projectUser : ProjectUserSession = gd.session.projectUsers.findByProjectAndUser(id, this.userId)

                if (projectUser?.inheritance !== UserInheritance.INHERITED) {
                    project = gd.session.projects.get(id)!
                }

                return !!project
            })


            return project!
        } else {
            return this.project
        }
    }
}
